export default __webpack_public_path__ + "static/media/ZEUS2.caf3ba2d.jpg";